import { StatusVolume } from "models/volumes/status"
import { validateHoursAreEqual } from "utils/custom-functions";

export const StatusRequest = {
  NotStarted: 0,
  Loading: 1,
  Success: 2,
  Error: 3
}

export const initialFilterLoadBuilding = {
  BusinessUnitId: null,
  SupplierId: null,
  MaterialNumber: [],
  _minDeliveryDate: new Date(new Date().setDate(new Date().getDate() - 1)).toISOString(),
  _maxDeliveryDate: "",
  _minCollectDate: '',
  _maxCollectDate: '',
  Status: [StatusVolume.AguardandoInformacoesTransporte],
  _page: 0,
  _size: 100,
}

export const validateValidFilter = (filter) => filter?.BusinessUnitId && filter.SupplierId

export const initialLoadSettingsData = {
  Door: null,
  TruckSize: "",
  AvailableDeliverySlots: false
};

export const mustInsertAJustificationToVolumeChange = (itemA, itemB) => {
  const propsChanged = [];
  const itemAProps = Object.getOwnPropertyNames(itemA);
  
  for (const propName of itemAProps) {
    if(propName === 'DeliveryTime' && itemA[propName] && itemB[propName]) {
      const _hoursDiferent = !validateHoursAreEqual(itemA[propName], itemB[propName]);
      if(_hoursDiferent) propsChanged.push(propName);
    } else if (itemA[propName] !== itemB[propName]) {
      propsChanged.push(propName);
    }
  }
  
  return propsChanged.length > 0 && verifyChangedAPropsThatNeedsJustification(propsChanged);
}

const verifyChangedAPropsThatNeedsJustification = (propsChanged) => {
  const _propsThatNeedsJustification = [
    'PickupDate',
    'DeliveryDate',
    'PendingVolume'
  ];

  return propsChanged.some(prop => _propsThatNeedsJustification.includes(prop));
}